import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SELECTED_BRANCH_TOKEN } from '../tokens/selected-org.token';
import { switchMap, take, map } from 'rxjs';
import { environment } from '@env/environment';

export const branchInterceptor: HttpInterceptorFn = (req, next) => {
  const isApiRequest =
    req.url.startsWith(environment.apiBaseUrl) ||
    req.url.startsWith(environment.apiAuthUrl) ||
    req.url.startsWith(environment.apiAccountUrl);

  if (!isApiRequest) {
    return next(req);
  }

  const selectedBranch$ = inject(SELECTED_BRANCH_TOKEN);

  return selectedBranch$.pipe(
    take(1),
    map((selectedBranch) => selectedBranch?.id || null),
    switchMap((branchId) => {
      const modifiedReq = branchId
        ? req.clone({ setHeaders: { 'x-branch-id': branchId } })
        : req;
      return next(modifiedReq);
    })
  );
};
